import loadable from '@loadable/component';

const NavBarBottomLazy = loadable(() => import('../containers/NavBarBottom'));

export default NavBarBottomLazy;
